var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffiReason6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1093_1281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM18 28H6C5.46957 28 4.96086 28.2107 4.58579 28.5858C4.21071 28.9609 4 29.4696 4 30V42C4 42.5304 4.21071 43.0391 4.58579 43.4142C4.96086 43.7893 5.46957 44 6 44H18C18.5304 44 19.0391 43.7893 19.4142 43.4142C19.7893 43.0391 20 42.5304 20 42V30C20 29.4696 19.7893 28.9609 19.4142 28.5858C19.0391 28.2107 18.5304 28 18 28ZM42 4H30C29.4696 4 28.9609 4.21071 28.5858 4.58579C28.2107 4.96086 28 5.46957 28 6V18C28 18.5304 28.2107 19.0391 28.5858 19.4142C28.9609 19.7893 29.4696 20 30 20H42C42.5304 20 43.0391 19.7893 43.4142 19.4142C43.7893 19.0391 44 18.5304 44 18V6C44 5.46957 43.7893 4.96086 43.4142 4.58579C43.0391 4.21071 42.5304 4 42 4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28H44M36 36H44M28 44H44",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1093_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiReason6);
export default __webpack_public_path__ + "static/media/affiReason6.891e00527ce6b79e3bac831860b13f7f.svg";
export { ForwardRef as ReactComponent };